import { ZpusobZpristupneni } from "./types";

export const messages = {
  [ZpusobZpristupneni.NAHLIZENI]: "Nahlížení",
  [ZpusobZpristupneni.REPLIKA]: "Reprodukce a replika",
  [ZpusobZpristupneni.OVERENI_SHODY]: "Ověření shody",
}
